import { apiCall } from "./index";
//  Departments API
export const fetchDepartments = async () => {
  try {
    const cached = localStorage.getItem("departments");
    if (cached) return JSON.parse(cached);

    const data = await apiCall("/departments", "GET");
    const departments = data?.data || [];

    localStorage.setItem("departments", JSON.stringify(departments));
    return departments;
  } catch (error) {
    console.error("Error fetching departments:", error);
    return [];
  }
};

// Shifts API
export const fetchShifts = async () => {
  try {
    const cached = localStorage.getItem("shifts");
    if (cached) return JSON.parse(cached);

    const data = await apiCall("/shifts", "GET");
    const shifts = data?.data || [];

    localStorage.setItem("shifts", JSON.stringify(shifts));
    return shifts;
  } catch (error) {
    console.error("Error fetching shifts:", error);
    return [];
  }
};

//  Designations API
export const fetchDesignations = async () => {
  try {
    const cached = localStorage.getItem("designations");
    if (cached) return JSON.parse(cached);

    const data = await apiCall("/designations", "GET");
    const designations = data?.data || [];

    localStorage.setItem("designations", JSON.stringify(designations));
    return designations;
  } catch (error) {
    console.error("Error fetching designations:", error);
    return [];
  }
};

// Roles API
export const fetchRoles = async () => {
  try {
    const cached = localStorage.getItem("roles");
    if (cached) return JSON.parse(cached);

    const data = await apiCall("/roles", "GET");
    const roles = data?.roles || [];

    localStorage.setItem("roles", JSON.stringify(roles));
    return roles;
  } catch (error) {
    console.error("Error fetching roles:", error);
    return [];
  }
};

//  Branches API
export const fetchBranches = async () => {
  try {
    const cached = localStorage.getItem("branches");
    if (cached) return JSON.parse(cached);

    const data = await apiCall("/branches", "GET");
    const branches = data?.data || [];

    localStorage.setItem("branches", JSON.stringify(branches));
    return branches;
  } catch (error) {
    console.error("Error fetching branches:", error);
    return [];
  }
};
